var render, staticRenderFns
import script from "./detailCold.vue?vue&type=script&lang=js&"
export * from "./detailCold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c9821c",
  null
  
)

export default component.exports